// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__cVdRE {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.knowledgeBaseHeader__Z4qj0 {
  padding: 20px 0 20px 20px;
}

.headerText__N8xWM.headerText__N8xWM {
  height: 31px;

  font-size: 24px;
  font-weight: 600;
  font-style: normal;
  line-height: 31px;
}

.headerTextPt__fHRI2.headerTextPt__fHRI2 {
  font-size: 16px;
  line-height: 34px;
}

.knowledgeBaseHeaderRedirect__zYcv0 {
  margin-bottom: 3px;
}

.wrapper__vqTt9 {
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 100%;

  background: white;
}

.knowledgeBaseList__eYTxU {
  overflow: auto;
  padding-bottom: 16px;
}

.articleItem__uRuXp {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;

  padding: 12px 20px;
}

.articleItem__uRuXp:hover {
  cursor: pointer;
}

.articleItem__uRuXp span {
  overflow: hidden;

  max-width: 290px;

  text-wrap: balance;
  font-size: 14px;
  line-height: 22px;
}

.footerWrapper__R9uLH {
  position: relative;
  text-align: center;
}

.footerUpperBackground__Q_9YM {
  position: absolute;
  right: 0;
  bottom: 32px;
  left: 0;

  height: 24px;

  background: linear-gradient(180deg, rgb(255 255 255 / 0%) 0%, #fff 100%);
}
`, "",{"version":3,"sources":["webpack://./src/components/KnowledgeBase/KnowledgeBase.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;;EAEZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;;EAE9B,YAAY;;EAEZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;;EAE9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;;EAEhB,gBAAgB;;EAEhB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,OAAO;;EAEP,YAAY;;EAEZ,wEAAwE;AAC1E","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.knowledgeBaseHeader {\n  padding: 20px 0 20px 20px;\n}\n\n.headerText.headerText {\n  height: 31px;\n\n  font-size: 24px;\n  font-weight: 600;\n  font-style: normal;\n  line-height: 31px;\n}\n\n.headerTextPt.headerTextPt {\n  font-size: 16px;\n  line-height: 34px;\n}\n\n.knowledgeBaseHeaderRedirect {\n  margin-bottom: 3px;\n}\n\n.wrapper {\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  height: 100%;\n\n  background: white;\n}\n\n.knowledgeBaseList {\n  overflow: auto;\n  padding-bottom: 16px;\n}\n\n.articleItem {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  justify-content: space-between;\n\n  padding: 12px 20px;\n}\n\n.articleItem:hover {\n  cursor: pointer;\n}\n\n.articleItem span {\n  overflow: hidden;\n\n  max-width: 290px;\n\n  text-wrap: balance;\n  font-size: 14px;\n  line-height: 22px;\n}\n\n.footerWrapper {\n  position: relative;\n  text-align: center;\n}\n\n.footerUpperBackground {\n  position: absolute;\n  right: 0;\n  bottom: 32px;\n  left: 0;\n\n  height: 24px;\n\n  background: linear-gradient(180deg, rgb(255 255 255 / 0%) 0%, #fff 100%);\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `container__cVdRE`;
export var knowledgeBaseHeader = `knowledgeBaseHeader__Z4qj0`;
export var headerText = `headerText__N8xWM`;
export var headerTextPt = `headerTextPt__fHRI2`;
export var knowledgeBaseHeaderRedirect = `knowledgeBaseHeaderRedirect__zYcv0`;
export var wrapper = `wrapper__vqTt9`;
export var knowledgeBaseList = `knowledgeBaseList__eYTxU`;
export var articleItem = `articleItem__uRuXp`;
export var footerWrapper = `footerWrapper__R9uLH`;
export var footerUpperBackground = `footerUpperBackground__Q_9YM`;
export default ___CSS_LOADER_EXPORT___;
